document.addEventListener('DOMContentLoaded', function () {
  initAccordionImageSections();
});

function initAccordionImageSections() {
  const sections = document.querySelectorAll('.accordionImageSection');

  sections.forEach((section) => {
    const items = section.querySelectorAll('.accordionImageSection_item');

    items.forEach((item) => {
      const trigger = item.querySelector('.accordionImageSection_trigger');
      const content = item.querySelector('.accordionImageSection_content-panel');

      if (!trigger || !content) return;

      trigger.addEventListener('click', () => {
        const isActive = item.classList.contains('is-active');

        items.forEach((otherItem) => {
          if (otherItem === item) return;
          const otherContent = otherItem.querySelector('.accordionImageSection_content-panel');
          if (otherContent) collapseItem(otherItem, otherContent);
        });

        if (isActive) {
          collapseItem(item, content);
        } else {
          expandItem(item, content);
        }
      });
    });

    window.addEventListener('resize', () => {
      const activeItems = section.querySelectorAll('.accordionImageSection_item.is-active');
      activeItems.forEach((item) => {
        const content = item.querySelector('.accordionImageSection_content-panel');
        if (content) content.style.maxHeight = content.scrollHeight + 'px';
      });
    });
  });
}

function expandItem(item, content) {
  item.classList.add('is-active');
  content.style.maxHeight = content.scrollHeight + 'px';
}

function collapseItem(item, content) {
  item.classList.remove('is-active');
  content.style.maxHeight = '0px';
}
